<!-- 由 suu 创建于 2021-11-17 星期三 -->
<template>
  <div class="cal-top">
    <div
      class="tab-item"
      :class="{ 'cal-tab-active': curTop == 0 }"
      @click="onTop(0)"
    >
      月度统计
    </div>
    <div
      class="tab-item"
      :class="{ 'cal-tab-active': curTop == 1 }"
      @click="onTop(1)"
    >
      年度统计
    </div>
  </div>
</template>

<script>
export default {
  name: 'cal-top',

  components: {},

  props: {},

  data() {
    return {
      curTop: 0
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 点击tab
     */
    onTop(i) {
      this.curTop = i
      this.$emit('top', i)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.cal-top {
  width: 100%;
  height: 11.7vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  box-sizing: border-box;
  // position: sticky;
  // top: 0px;
  z-index: 79;
  .tab-item + .tab-item {
    margin-left: 23.2vw;
  }
  .tab-item {
    font-size: 3.7vw;
    color: #000000;
    font-weight: 500;
  }

  .cal-tab-active {
    color: #000;
    position: relative;
    font-weight: bold;
  }
  .cal-tab-active:after {
    content: '';
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    bottom: vw(0);
    width: 5.3vw;
    height: 0.8vw;
    background-color: #dc0050;
    z-index: 1;
    bottom: -2.6vw;
  }
}
</style>
